import { useNavigation } from 'modules/core/hooks/useNavigation'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { FW_VISIT_STORAGE_KEY } from '../components/Table/table/hooks/useVisitTracking'

export const useVisitFWRoutes = ({ source }: { source: string }) => {
  const { navigation } = useNavigation()
  const [_, setStorage] = useLocalStorage<string>(FW_VISIT_STORAGE_KEY)

  return {
    financialWorkspaceRoute: () => {
      setStorage(source)

      return navigation.finance.financial_workspace.fullPath()
    },

    financialWorkspacePayrollRoute: () => {
      setStorage(source)

      return navigation.finance.financial_workspace.payroll.fullPath()
    },
  }
}
